module.exports = __webpack_public_path__ + "media/images/voice01-2-98483e77df1811fa9100e0d9dc6113d2.jpg";